import { useEffect } from 'react'
import { GetStaticProps } from 'next'
import { googleMapLibraries } from 'constants/common'
import withGoogleMapsScript from 'hoc/withGoogleMapsScript'
import { getFilters } from 'dataSource/ProviderSearch'
import { getFilterLookup, groupFilters } from 'app/ProviderSearch/utils'
import _isEmpty from 'lodash/isEmpty'
import _omit from 'lodash/omit'
import SearchPage from 'app/ProviderSearch/Pages/SearchPage'
import { handleCaptureRwgToken } from 'utils/rwgConversionTracking'

const ProvidersListingPage: React.FC<ProvidersListingPageProps> = ({
  groupedFilters,
  filterLookup,
}) => {
  // Capture RwG token from URL if available
  useEffect(handleCaptureRwgToken, [])

  return (
    <SearchPage groupedFilters={groupedFilters} filterLookup={filterLookup} />
  )
}

export const getStaticProps: GetStaticProps<ProvidersListingPageProps> = async () => {
  const response = await getFilters()
  const groupedFilters = groupFilters(response.result)
  const filterLookup = getFilterLookup(response.result)
  const totalFilterList = response.result.length

  return {
    props: { groupedFilters, filterLookup, totalFilterList },
    revalidate: 1,
  }
}

export default withGoogleMapsScript(ProvidersListingPage, [
  googleMapLibraries.GEOMETRY,
  googleMapLibraries.DRAWING,
  googleMapLibraries.PLACES,
])
